import styles from "./Records.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { MdOutlineTextSnippet } from "react-icons/md";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

import RecordsCard from "../../components/RecordsCard/RecordsCard";
import  SamplePhoto from './../../assets/images/Photo.png'


const mockData = [
  {
    type: "Concern",
    description: "Some text",
    students: ["Student 1", "Student 2"],
    staff: ["Staff A", "Staff B"],
    lessons: ["English", "Maths"],
    footerNote: "Final comment goes here",
    time: "1:30 PM",
    createdAt: "5th July 2025",
    likes: 2,
    views: 10,
    comments: 1,
    labels: {
      students: "Learners",
      staff: "Mentors",
      lessons: "Topics Covered",
    },
    image: SamplePhoto,
  },
  {
    type: "Concern",
    description:
      "Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.",
    students: ["Student 1", "Student 1", "Student 1"],
    staff: ["Student 1", "Student 1", "Student 1"],
    lessons: ["Maths", "Science"],
    footerNote:
      "Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.Observation is the active acquisition of information from a primary source using senses or instruments. It is a fundamental method in scientific inquiry, research, and daily life.",
    createdAt: "3rd June 2025",
    time: "12:00 PM",
    likes: 0,
    views: 0,
    comments: 1,
    image: SamplePhoto,
  },
];
  

function Records() {
  const [selectedDate, setSelectedDate] = useState("");
  const dispatch = useDispatch();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [selectedIds, setSelectedIds] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal("addFeePlan"));
  };




  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}
        <div className={styles.createForm}>
          <IconAndName
            icon={<MdOutlineTextSnippet />}
            title="Create Assessment"
            bgColor="Primary_Color"
            onClick={handlecreateform}
          />
        </div>

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search  by student name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <div className={styles.filters}>
              <Dropdown label="Room" options={["Live", "Inactive", "Draft"]} />
              <Dropdown
                label="Template"
                options={["Live", "Inactive", "Draft"]}
              />
              <CalendarInput
                label="Date"
                value={selectedDate}
                onChange={setSelectedDate}
                background="var(--Utility_Color1)"
                textColor="gray"
                iconColor="gray"
                placeholderColor="gray"
                borderRadius="25px"
                shadow={false}
              />
              <Dropdown
                label="Status"
                options={["Live", "Inactive", "Draft"]}
              />
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.cardGrid}>
              {mockData.map((record, index) => (
                <RecordsCard key={index} data={record} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Records;
